export default "<div class=\"text-center\">\n    <h2>Nossas unidades</h2>\n    <i class=\"fas fa-chevron-down fa-3x\"></i>\n</div>\n"